@if (label()) {
  <div
    class="checklist-task-label label text-primary"
    [class.sr-only]="hideLabel()">
    {{ label() }}
    @if (isRequired) {
      <span class="text-error-primary">*</span>
    }
  </div>
}

@if (!isReadOnly()) {
  <div class="mt-2" data-presence-target>
    <app-file-upload
      [checklistId]="checklistId"
      [itemId]="itemId"
      [customInputId]="customInputId"
      [maxFiles]="maxFiles()"
      [files]="files"
      [accept]="accept"
      [readOnly]="isReadOnly()"
      [helperText]="helperText"
      [buttonLabel]="'Add picture'"
      [compactMode]="true"
      [beforePersist]="promoteIfPreview"
      (fileUploaded)="onFileUploaded($event)"
      (fileRemoved)="onFileRemoved($event)"
      (uploadError)="onUploadError($event)">
      @if (files.length > 0) {
        @for (file of files; track file.id) {
          <app-image-thumbnail
            [fileId]="file.id"
            [readOnly]="isReadOnly()"
            (remove)="removeFile(file.id)"
            (view)="openPreview(file.id)" />
        }
      }
    </app-file-upload>
  </div>
} @else {
  @if (isIsolatedPreview()) {
    <div class="mt-2" data-testid="preview-image-upload">
      <app-button
        [text]="'Add picture'"
        [type]="ButtonType.SecondarySubtle"
        [borderRadius]="'rounded-lg'"
        [leftIcon]="'/assets/svg/image.svg'"
        [disabled]="true" />
      <p class="mt-2 text-xs text-tertiary">{{ helperText }}</p>
    </div>
  }
  <div class="grid grid-cols-3 gap-2 mt-1.5">
    @for (file of files; track file.id) {
      <app-image-thumbnail
        [fileId]="file.id"
        [readOnly]="isReadOnly()"
        (remove)="removeFile(file.id)"
        (view)="openPreview(file.id)" />
    }
  </div>
}

@if (isReadOnly() && !isIsolatedPreview() && files.length === 0) {
  <p class="mt-1.5 text-sm text-tertiary">No pictures added.</p>
}

@if (previewFileId) {
  <app-image-preview-modal
    [fileId]="previewFileId"
    [fileIds]="previewFileIds"
    (navigate)="showPreviewFile($event)"
    (close)="closePreview()" />
}
